module.exports = __webpack_public_path__ + "static/fammix-a6bc95c93fa2a1650ffa3a4e481c7e8a.jpg";